document.addEventListener('alpine:init', () => {
  Alpine.data('mountUpsell', () => ({
    enabled: false,
    drawerOpen: false,
    selectedBoard: null,
    selectedOpening: null,
    openingFilter: '',
    mountVariantId: null,
    mountWidth: 0,
    mountHeight: 0,
    mountName: '',
    mountPrice: '',
    productTitle: '',

    hasMountData: false,
    _variantMap: {},
    _allOpenings: [],
    _unsubscribe: null,

    OVERLAP_MM: 3,

    get coreColour() {
      return this.selectedBoard?.color || '#ffffff';
    },

    init() {
      var mapEl = document.getElementById(this.$el.dataset.variantMapId);
      if (mapEl) {
        try { this._variantMap = JSON.parse(mapEl.textContent); } catch (e) { this._variantMap = {}; }
      }

      this.sectionId = this.$el.dataset.section || '';
      this.productTitle = this.$el.dataset.productTitle || '';

      var initialId = this.$el.dataset.initialVariantId;
      this._applyVariantData(initialId);

      var self = this;
      this.$nextTick(function() {
        self._sortBoardButtons();
        self._preselectDefaults();
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        var self = this;
        this._unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
          var variant = event.data?.variant;
          if (!variant || event.data.sectionId !== self.sectionId) return;
          self._onVariantChange(variant.id);
        });
      }
    },

    destroy() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    },

    _applyVariantData(variantId) {
      var key = String(variantId);
      var data = this._variantMap[key];
      if (data) {
        this.mountVariantId = data.mountVariantId;
        this.mountWidth = data.mountWidth || 0;
        this.mountHeight = data.mountHeight || 0;
        this.mountName = data.mountName || '';
        this.mountPrice = data.mountPrice || '';
        this._allOpenings = data.openings || [];
        this._defaultOpeningName = data.defaultOpening || '';
        this.hasMountData = true;
      } else {
        this.mountVariantId = null;
        this.mountWidth = 0;
        this.mountHeight = 0;
        this.mountName = '';
        this.mountPrice = '';
        this._allOpenings = [];
        this._defaultOpeningName = '';
        this.hasMountData = false;
      }
    },

    _onVariantChange(variantId) {
      var wasEnabled = this.enabled;
      var prevBoard = this.selectedBoard;

      this._applyVariantData(variantId);

      if (!this.hasMountData) {
        if (wasEnabled) {
          this.enabled = false;
          this._syncSubmitButtonText();
        }
        if (this.drawerOpen) {
          this.closeDrawer();
        }
      }

      this.selectedOpening = null;
      this.openingFilter = '';
      this._preselectDefaultOpening();

      if (prevBoard && this.hasMountData) {
        this.selectedBoard = prevBoard;
      }
    },

    // -- Drawer --

    openDrawer() {
      this.drawerOpen = true;
      document.body.style.overflow = 'hidden';
      if (typeof window.sbaTrack === 'function') {
        window.sbaTrack('mount_configurator_opened', {
          product_title: this.productTitle || undefined,
        });
      }
      this.$nextTick(function() {
        var closeBtn = document.querySelector('.mu-drawer__close');
        if (closeBtn) closeBtn.focus();
      });
    },

    closeDrawer() {
      this.drawerOpen = false;
      document.body.style.overflow = '';
      this.openingFilter = '';
    },

    confirmMount() {
      if (!this.isComplete) return;
      this.enabled = true;
      if (typeof window.sbaTrack === 'function') {
        window.sbaTrack('mount_configured', {
          mount_board: this.selectedBoard ? this.selectedBoard.name : undefined,
          mount_opening: this.selectedOpening ? this.selectedOpening.name : undefined,
          product_title: this.productTitle || undefined,
        });
      }
      this._syncSubmitButtonText();
      this.closeDrawer();
    },

    removeMount() {
      this.enabled = false;
      this._syncSubmitButtonText();
    },

    // -- Computed --

    get isComplete() {
      return this.selectedBoard && this.selectedOpening;
    },

    get windowCutWidth() {
      if (!this.selectedOpening) return 0;
      return this.selectedOpening.widthMm - (this.OVERLAP_MM * 2);
    },

    get windowCutHeight() {
      if (!this.selectedOpening) return 0;
      return this.selectedOpening.heightMm - (this.OVERLAP_MM * 2);
    },

    get windowCutLabel() {
      if (!this.selectedOpening) return '\u2014';
      return this.windowCutWidth + ' \u00d7 ' + this.windowCutHeight + ' mm';
    },

    get borderH() {
      if (!this.selectedOpening || !this.mountWidth) return 0;
      return (this.mountWidth - this.windowCutWidth) / 2;
    },

    get borderV() {
      if (!this.selectedOpening || !this.mountHeight) return 0;
      return (this.mountHeight - this.windowCutHeight) / 2;
    },

    get bordersLabel() {
      if (!this.selectedOpening || !this.mountWidth) return '\u2014';
      var h = Math.round(this.borderH * 10) / 10;
      var v = Math.round(this.borderV * 10) / 10;
      if (h === v) return h + ' mm all round';
      return h + ' mm left/right, ' + v + ' mm top/bottom';
    },

    get bevelWidth() {
      if (!this.isComplete) return 0;
      var shortest = Math.min(this.mountWidth, this.mountHeight);
      return Math.max(1.5, Math.min(4, shortest * 0.012));
    },

    // -- Grouped & filtered openings --

    get groupedOpenings() {
      var filter = this.openingFilter.toLowerCase().trim();
      var openings = this._allOpenings;
      if (filter) {
        openings = openings.filter(function(o) {
          return o.name.toLowerCase().indexOf(filter) !== -1 ||
                 o.dims.toLowerCase().indexOf(filter) !== -1;
        });
      }

      var groups = {};
      var order = [];
      openings.forEach(function(o) {
        var cat = o.category || 'other';
        if (!groups[cat]) {
          groups[cat] = { category: cat, label: '', items: [] };
          order.push(cat);
        }
        groups[cat].items.push(o);
      });

      var labels = {
        'standard': 'Standard',
        'iso': 'ISO Paper',
        'imperial': 'Imperial',
        'photo': 'Photo',
        'poster': 'Poster & Art',
        'metric': 'Metric',
        'jis': 'JIS Japanese',
        'other': 'Other'
      };

      order.forEach(function(cat) {
        groups[cat].label = labels[cat] || (cat.charAt(0).toUpperCase() + cat.slice(1));
      });

      return order.map(function(cat) { return groups[cat]; });
    },

    get filteredOpeningCount() {
      var count = 0;
      this.groupedOpenings.forEach(function(g) { count += g.items.length; });
      return count;
    },

    // -- SVG helpers --

    _hexToRgb(hex) {
      var h = hex.replace('#', '');
      if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
      var n = parseInt(h, 16);
      return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
    },

    _rgbStr(r, g, b) {
      return 'rgb(' + Math.round(r) + ',' + Math.round(g) + ',' + Math.round(b) + ')';
    },

    _blendChannel(c, target, factor) {
      return c + (target - c) * factor;
    },

    get _bevelDark() {
      var rgb = this._hexToRgb(this.coreColour);
      return this._rgbStr(this._blendChannel(rgb[0], 0, 0.35), this._blendChannel(rgb[1], 0, 0.35), this._blendChannel(rgb[2], 0, 0.35));
    },

    get _bevelBright() {
      var rgb = this._hexToRgb(this.coreColour);
      return this._rgbStr(this._blendChannel(rgb[0], 255, 0.4), this._blendChannel(rgb[1], 255, 0.4), this._blendChannel(rgb[2], 255, 0.4));
    },

    get _bevelMidLight() {
      var rgb = this._hexToRgb(this.coreColour);
      return this._rgbStr(this._blendChannel(rgb[0], 255, 0.2), this._blendChannel(rgb[1], 255, 0.2), this._blendChannel(rgb[2], 255, 0.2));
    },

    get _bevelMidDark() {
      var rgb = this._hexToRgb(this.coreColour);
      return this._rgbStr(this._blendChannel(rgb[0], 0, 0.15), this._blendChannel(rgb[1], 0, 0.15), this._blendChannel(rgb[2], 0, 0.15));
    },

    get _padX() { return this.mountWidth * 0.06; },
    get _padY() { return this.mountHeight * 0.06; },
    get _winX() { return this._padX + this.borderH; },
    get _winY() { return this._padY + this.borderV; },

    get _bevelTopPoints() {
      var bw = this.bevelWidth, ox = this._winX, oy = this._winY, w = this.windowCutWidth;
      return (ox-bw)+','+(oy-bw)+' '+(ox+w+bw)+','+(oy-bw)+' '+(ox+w)+','+(oy)+' '+(ox)+','+(oy);
    },

    get _bevelBottomPoints() {
      var ox = this._winX, oy = this._winY, w = this.windowCutWidth, h = this.windowCutHeight, bw = this.bevelWidth;
      return (ox)+','+(oy+h)+' '+(ox+w)+','+(oy+h)+' '+(ox+w+bw)+','+(oy+h+bw)+' '+(ox-bw)+','+(oy+h+bw);
    },

    get _bevelLeftPoints() {
      var ox = this._winX, oy = this._winY, h = this.windowCutHeight, bw = this.bevelWidth;
      return (ox-bw)+','+(oy-bw)+' '+(ox)+','+(oy)+' '+(ox)+','+(oy+h)+' '+(ox-bw)+','+(oy+h+bw);
    },

    get _bevelRightPoints() {
      var ox = this._winX, oy = this._winY, w = this.windowCutWidth, h = this.windowCutHeight, bw = this.bevelWidth;
      return (ox+w)+','+(oy)+' '+(ox+w+bw)+','+(oy-bw)+' '+(ox+w+bw)+','+(oy+h+bw)+' '+(ox+w)+','+(oy+h);
    },

    get _annoFontSize() { return Math.min(this.mountWidth, this.mountHeight) * 0.045; },
    get _annoGap() { return this._annoFontSize * 0.6; },
    get _annoTick() { return this._annoFontSize * 0.4; },
    get _annoStroke() { return this._annoFontSize * 0.06; },
    get _annoBottomY() { return this._padY + this.mountHeight + this._annoGap; },
    get _annoRightX() { return this._padX + this.mountWidth + this._annoGap; },
    get _annoHeightTextX() { return this._annoRightX + this._annoFontSize * 1.2; },
    get _annoHeightRotate() {
      var cx = this._annoHeightTextX, cy = this._padY + this.mountHeight / 2;
      return 'rotate(-90,' + cx + ',' + cy + ')';
    },

    // -- Board & opening selection --

    selectBoard(name, color, value) {
      this.selectedBoard = { name: name, color: color, value: value };
    },

    selectOpening(name, widthMm, heightMm) {
      this.selectedOpening = { name: name, widthMm: widthMm, heightMm: heightMm };
    },

    isBoardSelected(name) {
      return this.selectedBoard?.name === name;
    },

    _sortBoardButtons() {
      var grid = document.querySelector('.mu-board-grid');
      if (!grid) return;
      var buttons = Array.from(grid.querySelectorAll('.mu-board-btn'));
      buttons.sort(function(a, b) {
        return (parseInt(a.dataset.sortOrder, 10) || 999) - (parseInt(b.dataset.sortOrder, 10) || 999);
      });
      buttons.forEach(function(btn) { grid.appendChild(btn); });
    },

    _preselectDefaults() {
      var firstBtn = document.querySelector('.mu-board-btn');
      if (firstBtn) {
        this.selectBoard(firstBtn.dataset.boardName, firstBtn.dataset.boardHex, firstBtn.dataset.boardCode);
      }
      this._preselectDefaultOpening();
    },

    _preselectDefaultOpening() {
      if (this._allOpenings.length === 0) return;
      var o = null;
      if (this._defaultOpeningName) {
        o = this._allOpenings.find(function(item) { return item.name === this._defaultOpeningName; }.bind(this));
      }
      if (!o) o = this._allOpenings[0];
      this.selectOpening(o.name, o.widthMm, o.heightMm);
    },

    _syncSubmitButtonText() {
      var sectionEl = this.$el.closest('[data-section]');
      var sectionId = sectionEl ? sectionEl.dataset.section : this.sectionId;
      if (!sectionId) return;
      var btn = document.getElementById('ProductSubmitButton-' + sectionId);
      if (!btn) return;
      var span = btn.querySelector('span');
      if (!span) return;

      if (this.enabled && this.hasMountData) {
        span.textContent = 'Add Frame + Mount';
      } else {
        span.textContent = window.variantStrings?.addToCart || 'Add to cart';
      }
    },

    getMountCartItem() {
      if (!this.enabled || !this.isComplete || !this.mountVariantId) return null;
      return {
        id: this.mountVariantId,
        quantity: 1,
        properties: {
          'Mount Board': this.selectedBoard.name,
          'Window Opening': this.selectedOpening.name + ' (' + this.selectedOpening.widthMm + ' \u00d7 ' + this.selectedOpening.heightMm + ' mm)',
          'Window Cut': this.windowCutWidth + ' \u00d7 ' + this.windowCutHeight + ' mm'
        }
      };
    }
  }));
});
